const {AllowEditButton} = require('./AllowEditButton')
const {Breadcrumbs} = require('./Breadcrumbs')
const {DeleteDatabaseModal} = require('./DeleteDatabaseModal')
const {DeleteDocModal} = require('./DeleteDocModal')
const {Editor} = require('./Editor')
const {ErrorDisplay} = require('./ErrorDisplay')
const {Footer} = require('./Footer')
const {Loading} = require('./Loading')
const {Login} = require('./Login')
const {Modal} = require('./Modal')
const {NewDatabaseModal} = require('./NewDatabaseModal')
const {NewDoc} = require('./NewDoc')
const {Pagination} = require('./Pagination')
const {ButtonLink} = require('./ButtonLink')

module.exports = {
  AllowEditButton,
  Breadcrumbs,
  DeleteDatabaseModal,
  DeleteDocModal,
  Editor,
  ErrorDisplay,
  Footer,
  Loading,
  Login,
  Modal,
  NewDatabaseModal,
  NewDoc,
  Pagination,
  ButtonLink
}
